// extracted by mini-css-extract-plugin
export default {"ratingStage":"ratingStage-MZKSlt_P"};